import React from 'react';
import { ChatIcon } from '@heroicons/react/solid';

const EmptyChat = () => {
  return (
    <div className="flex-1 flex flex-col items-center justify-center bg-gray-100 space-y-4">
      <ChatIcon className="w-20 h-20 text-gray-300" />
      <h2 className="text-xl text-gray-500">Select a chat to start messaging</h2>
    </div>
  );
};

export default EmptyChat;
